import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

import { authState } from '~/features/auth/state';

import { clmUserApiClient } from '../clients';
import type {
  AdminUser,
  AdminUserCreateRequest,
  AdminUserCreateRequestBody,
} from '../types';
import { isApiErrorResponse } from '../utils';

const createAdminUser = async (
  data: AdminUserCreateRequest,
): Promise<AdminUser> => {
  const idnId = authState.getIDNId();

  if (!idnId) {
    throw new Error('IDN ID is required to create an admin user.');
  }

  const response = await clmUserApiClient.post('user', {
    user: {
      ...data,
      idnId,
      // TODO: Temporary hardcoded values until System Engineering provides proper design or instructions how to set that
      country: 'us',
      language: 'en-US',
    },
  } as AdminUserCreateRequestBody);

  if (!response.ok) {
    if (isApiErrorResponse(response.data)) {
      throw new Error(response.data.details);
    }
    throw new Error('Unknown error');
  }

  return response.data as AdminUser;
};

export const useAdminUserCreateMutation = (
  config?: Omit<
    UseMutationOptions<AdminUser, Error, AdminUserCreateRequest>,
    'mutationFn'
  >,
) =>
  useMutation({
    mutationFn: createAdminUser,
    ...config,
  });
